/*
 * This JS is triggered on the Location roster entry
 */

// Setup the namespace for this logic
var ensureLocationsMarkedVisited = ensureLocationsMarkedVisited || {};


ensureLocationsMarkedVisited.initialize = function() {
	ap.consoleInfo("ensureLocationsMarkedVisited initialize!");

	if (page.type=="rosterEdit") {
		var field = page.getField("APVisitedIndicator");
		if (field) {
			value = field.getValue();
			if (!value || value!="true") {
				field.setValue("true");
			}
		}
	}
};